import { provideUtilitySheet } from "@pentacode/ui/components";
// eslint-disable-next-line import/no-unresolved
import sheet from "./uno.css?css-sheet";

provideUtilitySheet(sheet);
